import { Component, input, output } from '@angular/core';
import { IIcon } from '@core/interfaces/icon.interface';

@Component({
  template: '',
})
export abstract class ButtonBase {
  //#region I/O
  public readonly disabled = input<boolean>(false);
  public readonly icon = input<IIcon | null>(null);
  public readonly ariaLabel = input<string | null>(null);
  public readonly tabIndex = input<number | null>(null);

  public readonly onClick = output<void>();
  //#endregion
}
